import React, { useEffect, useState, useCallback } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaEdit, FaCircle } from "react-icons/fa";
import { toast } from "react-toastify";

import { api } from "../../api";

import { customStyles } from "../../styles/dataTableStyles";
import Swal from "sweetalert2";

const Products = ({ addAccess }) => {
  const token = useSelector((state) => state.auth.token);
  const region = useSelector((state) => state.auth.region);
  // eslint-disable-next-line
  const { userType: role } = useSelector((state) => state.auth.user);
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(50);

   

  const fetchProducts = useCallback(async (pageNo, searchKey, pageSize) => {
    try {
      setLoading(true);
      const response = await api.products.getProductsList(
        { pageNo, pageSize, sort: "desc", sortBy: "id", searchKey },
        token
      );
      if (response.success) {
        setProducts(response.data.result);
        setTotalRows(response.data.totalCount);
      }else {
        setProducts([]);
        setTotalRows(0);
      }
    } catch (error) {
      setProducts([]);
      setTotalRows(0);
      console.error("Error fetching products", error);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
  
        setPage(1);
      // eslint-disable-next-line
    }, [search]);

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      fetchProducts(page, search, pageSize);
    }, 500);
    return () => clearTimeout(delaySearch);
  }, [page, search, pageSize, fetchProducts]);

  

  const handleDelete = async (id) => {
    Swal.fire({
          title: "Are you sure?",
          text: "Do you really want to inactive this product?",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "rgb(112 110 115)",
          confirmButtonText: "Okay",
        }).then(async (result) => {
          if (result.isConfirmed) {
    try {
      await api.products.deleteProductById({ delete_array: [id], status: false },token);
      toast.success("Product deactivated successfully");
      fetchProducts(page, search, pageSize);
    } catch {
      toast.error("Something went wrong");
    }

      }
    });
  };

  const handleActivate = async (productId) => {
  Swal.fire({
          title: "Are you sure?",
          text: "Do you really want to activate this product?",
          showCancelButton: true,
          confirmButtonColor: "rgb(68, 170, 68)",
          cancelButtonColor: "rgb(112 110 115)",
          confirmButtonText: "Activate",
        }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await api.products.deleteProductById({ delete_array: [productId],"status":true  },token);
            toast.success("Product activated successfully");
            fetchProducts(page, search, pageSize);
          } catch {
            toast.error("Something went wrong");
          }

        }
      });
  };

  const columns = [
    { name: "ID", selector: row => row.productId, sortable: true, width: "80px" },
    { name: "Brand", selector: row => row.brand?.brandName || "-", sortable: true, width: "200px" },
    { name: "Denomination", selector: row => row.productName, sortable: true},
    { name: region.currency ? `Price (${region.currency})` : "Price", selector: row => row.productPrice, width: "100px" },
    {
      name: "Status",
      selector: row => (row.productStatus ? "Active" : "Inactive"),
      cell: row => (
        <span
          style={{
            padding: "5px 10px",
            borderRadius: "5px",
            // color: "#fff",
            // backgroundColor: row.productStatus ? "#44aa44" : "#ff4b4b",
            color: row.productStatus ? "#44aa44" : "#ff4b4b",
            display: "inline-block",
            minWidth: "80px",
            textAlign: "center",
          }}
        >
          {row.productStatus ? "Active" : "Inactive"}
        </span>
      ),
      width: "100px",
    },
    { name: "Sku", selector: row => row.sku, width: "200px" },
    {
      name: "Actions",
      cell: (row) => (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>

              {row.productStatus ? (
                 <>
                  <button className="btn btn-primary btn-sm" onClick={() => navigate(`/view-products/${row.productId}`)}>
                  View 
                </button>
                 <button className="listButton" onClick={() => navigate(`/edit-products/${row.productId}`)}>
                    <FaEdit />
                  </button>
                <button title="Click to Inactive" className="listButton" onClick={() => handleDelete(row.productId)}>
                  <FaCircle style={{ fill: 'green' }} />
                </button>
                 </>
              ) : (
                <button title="Click to Active" className="listButton" style={{ minWidth: "80px" }} onClick={() => handleActivate(row.productId)}>
                    <FaCircle style={{ fill: 'grey' }}/>
                  </button>
              )}
           
         
        </div>
      ),
      ignoreRowClick: true,
   
      width: "200px",
    },
  ];

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="sec-header" >PRODUCTS</h2>
        <div className="d-flex align-items-center">
          <label className="mr-2">Search:</label>
          <input
            type="text"
            placeholder="Product Name"
            className="form-control"
            style={{ width: "200px" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
       <button className="btn new-btn-top btn-primary" style={{ marginLeft: "10px", marginTop: "15px" }}  onClick={() => navigate(`/add-products`)}>
      ADD PRODUCT
    </button>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={products}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangePage={setPage}
        paginationPerPage={pageSize}
        onChangeRowsPerPage={(newPageSize, newPage) => {
          setPageSize(newPageSize);
          setPage(newPage);
        }}
        paginationRowsPerPageOptions={[50, 100,150,200]}
        highlightOnHover
        customStyles={customStyles}
        responsive
        noHeader={false}
        noTableHead={false}
        wrap
      />
    </div>
  );
};

export default Products;
